import { Children } from "react";
export const isHeaderRow = (dataItem) => Boolean(dataItem._headerRow);
const columnToLabeledRowMapper = (c) => {
    if (c && c.props["field"]) {
        const { title } = c.props;
        return { title: title || c.props["field"], field: c.props["field"] };
    }
};
const isLabeledRow = (row) => Boolean(row);
const setHeaderLabel = (dataItem, { title, field }) => {
    Object.assign(dataItem, { [field]: title });
    return dataItem;
};
/**
 * Instead of using the default kendo renderer for the header (which creates a
 * separate table), we render the header as a regular data row. For that, we
 * prepend the initial data with a special row that has the header label.
 */
export const useTableDataWithHeaderRow = (children, initialRowsData, initialOnDataChange, initialOnSelectionChange) => {
    // don't inject the header row if there is no data
    if (!initialRowsData || !initialRowsData.length) {
        return {
            data: initialRowsData,
            onDataChange: initialOnDataChange,
        };
    }
    const labeledHeaderRow = [Children.map(children, columnToLabeledRowMapper)]
        .flat()
        .filter(isLabeledRow)
        .reduce(setHeaderLabel, {});
    labeledHeaderRow._headerRow = true;
    const onDataChange = (data) => {
        initialOnDataChange === null || initialOnDataChange === void 0 ? void 0 : initialOnDataChange(data.slice(1));
    };
    const onSelectionChange = (selection) => {
        if (!initialOnSelectionChange) {
            return;
        }
        const items = selection.items.filter((i) => !isHeaderRow(i));
        initialOnSelectionChange(Object.assign(Object.assign({}, selection), { items }));
    };
    return {
        data: [labeledHeaderRow, ...initialRowsData],
        onDataChange,
        onSelectionChange,
    };
};
//# sourceMappingURL=useTableDataWithHeaderRow.js.map